import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useGclid } from '../hooks/useGclid';
import { buildShopUrl, trackCTAClick } from '../utils/tracking';
interface CTAButtonProps {
  label: string;
  position: string;
  className?: string;
}
const SHOP_URL = 'https://hunderunde.shop/products/futtertopping-magen-darm';
export function CTAButton({
  label,
  position,
  className = ''
}: CTAButtonProps) {
  const gclid = useGclid();
  const href = buildShopUrl(SHOP_URL, gclid);
  return <motion.a href={href} onClick={() => trackCTAClick(label, position)} target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.98
  }} className={`inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-white font-semibold text-lg shadow-lg transition-shadow hover:shadow-xl w-full md:w-auto ${className}`} style={{
    backgroundColor: 'var(--color-green)'
  }} data-id="element-25">
      {label}
      <ArrowRightIcon className="w-5 h-5" data-id="element-26" />
    </motion.a>;
}